module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.3330/img/favicon.png"